module.exports = __webpack_public_path__ + "img/camp02_actived.0791f638.png";